import React from "react";

function CategoryEmoji(props) {

    return (
        <div className="emoji">{props.category}</div>
    )
}
export default CategoryEmoji;